import * as React from 'react';
import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import {Theme} from '../../../stores/AppStore';

export enum ButtonVariant {
  Default = 'default',
  Dashed = 'dashed',
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const Container = styled.button<ButtonProps>`
  ${transition()};
  box-sizing: border-box;
  border: 2px dashed transparent;
  border-radius: 5px;
  height: 46px;
  width: 46px;
  
  justify-content: center;
  align-items: center;
  display: inline-grid;
  
  ${({theme, variant}) => {
    switch (variant) {
      case ButtonVariant.Default: return css`
        background-color: ${theme.name === Theme.Dark ? (
          transparentize(.95, theme.colors.white)
        ) : theme.variables.backgroundColor};
        
        &:hover,
        &:focus-visible {
          background-color: ${transparentize(.85, theme.colors.white)};
        }
      `;
      case ButtonVariant.Dashed: return css`
        border-color: ${theme.name === Theme.Dark ? (
          transparentize(.95, theme.colors.white)
        ) : theme.variables.borderColor};
        color: ${theme.name === Theme.Dark ? (
          transparentize(.7, theme.colors.white)
        ) : theme.variables.color};

        &:hover,
        &:focus-visible {
          border-color: ${transparentize(.85, theme.colors.white)};
          color: ${theme.name === Theme.Dark ? (
            theme.colors.white
          ) : transparentize(.5, theme.variables.color)};
        }
      `;
    }
  }};
`;

/**
 * This component will render a button in the footer of the card.
 * @param {ButtonProps} props
 * @return {React.ReactElement<ButtonProps>}
 * @constructor
 */
function Button(
    props: ButtonProps,
): React.ReactElement<ButtonProps> {
  return (
    <Container {...props} />
  );
}

Button.defaultProps = {
  variant: ButtonVariant.Default,
};

export default Button;
